<template>
  <div class="boxGenitorparte"
       :class="{ 'boxGenitorparte--decl': dados.declarante }">
    <div class="boxGenitorparte_header p-2">
      <h4 class="boxGenitorparte_header_title">
        {{ dados.pessoa.nome }}
      </h4>
    </div>

    <div class="boxGenitorparte_body py-2 pl-3">
      <div class="d-flex justify-content-between align-items-center">
        <p class="boxGenitorparte_body_text mb-0">
          Genitor
        </p>

        <div class="custom-control custom-switch custom-control-inline">
          <input :id="`ingoraSemanas-${id}`"
                 v-model="declarante"
                 class="custom-control-input"
                 :name="`ingoraSemanas-${id}`"
                 type="checkbox"
                 :disabled="!!dados.pessoa.falecido"
                 @change="changeGenitorDeclarante">
          <label class="custom-control-label"
                 :for="`ingoraSemanas-${id}`">Declarante</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BoxGenitorParte",
    props: {
      dados: {
        type: Object,
        default: () => {}
      },
      indice: {
        type: [Number, null],
        default: () => null
      },
    },
    data () {
      return {
        declarante: false,
        id: null,
      }
    },
    watch: {
      dados (newObj, oldObj) {
        this.checkDeclarante(newObj)
      }
    },
    beforeUpdate () {
      this.checkDeclarante(this.dados)
    },
    mounted () {
      this.id = this._uid
    },
    methods: {
      checkDeclarante (genitor) {
        this.declarante = genitor.declarante
      },
      changeGenitorDeclarante () {
        let obj = {
          ...this.dados,
          indice: this.indice,
          declarante: this.declarante
        }

        this.$emit('changeDeclarante', obj)
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .boxGenitorparte {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_header {
      //background-color: $sofiaRei-blue;
      background-color: $color-gray-light;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
      }
    }

    &_body {
      min-height: pxToRem(56);

      &_text {
        font-weight: 400;
      }
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }

    &--decl {
      .boxGenitorparte_header {
        background-color: $sofiaRei-blue;
      }
    }
  }
</style>
